import { FC, InputHTMLAttributes } from "react";

import styles from "./form.module.css";

interface Props extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  value: string;
  error?: string | null;
  onValueChange: (value: string) => void;
}

export const FormInput: FC<Props> = ({
  error,
  onValueChange,
  ...inputProps
}) => (
  <label className={styles.field}>
    <input
      {...inputProps}
      className={`${styles.input} ${error ? styles.inputInvalid : ""}`}
      aria-invalid={Boolean(error)}
      onChange={(event) => onValueChange(event.target.value)}
    />
    {error && <span className={styles.error}>{error}</span>}
  </label>
);
